import { Libraries } from "@react-google-maps/api";

// Shared library list - every useJsApiLoader/LoadScript call in the app must
// request the exact same set, or @react-google-maps/api throws at runtime.
export const mapLibraries: Libraries = ["places"];
